<template>
    <div>
        <UploadPrimisReportCard />

        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <PrimisBatch />
            </div>
        </div>


        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <BrokerBatch />
            </div>
        </div>
    </div>
</template>

<script>
import UploadPrimisReportCard from './Cards/UploadPrimisReport'
import PrimisBatch from './Cards/PrimisBatch'
import BrokerBatch from './Cards/BrokerBatch'

export default {
    name: 'BatchClientsView',
    components: {
        UploadPrimisReportCard,
        PrimisBatch,
        BrokerBatch,
    },
}
</script>
